import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
`;

export const ArrowWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 66px;
  position: relative;
  height: auto;
`;

export const CarouselWrapper = styled.div<{ isShowIndicator?: boolean }>`
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  scroll-behavior: smooth;
  justify-content: ${({ isShowIndicator }) => (isShowIndicator ? "flex-start" : "center")};
  width: auto;
  column-gap: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  width: calc(100% - 132px);

  div {
    flex-grow: 0; /* Prevents child from expanding */
    flex-shrink: 0; /* Prevents shrinking */
  }
`;

export const IndicatorWrapper = styled.div`
  width: calc(100% - 132px);
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  column-gap: 4px;
`;

export const ButtonArrow = styled.div<{
  isDarkMode: boolean;
  opacity: string;
  isDisabled: boolean;
}>`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background-color: ${({ isDarkMode }) => (isDarkMode ? "#1F2D3D" : "#fff")};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 3px 5px 0px #0000000d;
  box-shadow: 0px 1px 18px 0px #0000000d;
  box-shadow: 0px 6px 10px 0px #0000000d;
  cursor: pointer;
  opacity: ${({ opacity }) => opacity ?? "1"};
  transform: opacity 0.3s;

  &:hover {
    opacity: 1;
  }

  ${({ isDisabled, isDarkMode }) =>
    isDisabled && !isDarkMode
      ? css`
          svg path {
            fill: #dde2e8;
          }
        `
      : isDarkMode && !isDisabled
      ? css`
          svg path {
            fill: white;
          }
        `
      : css`
          svg path {
            fill: #6a7481;
          }
        `}
`;

export const Dots = styled.div<{ isActive: boolean; activeDotColor: string }>`
  width: ${(props) => (props?.isActive ? "16px" : "8px")};
  height: 8px;
  border-radius: 8px;
  background-color: ${(props) => (props?.isActive ? props?.activeDotColor ?? "grey" : "#B8C1CB")};
`;
